import { useNavigate } from 'react-router-dom';
import { Panel } from './Panel';

interface QuickAction {
  label: string;
  glyph: string;
  description: string;
  route?: string;
}

const ACTIONS: readonly QuickAction[] = [
  { label: 'Crimes', glyph: '☠', description: 'Earn your keep', route: '/crimes' },
  { label: 'Training', glyph: '⚔', description: 'Train your stats', route: '/training' },
  { label: 'Ships', glyph: '⚓', description: 'Coming soon' },
  { label: 'Shop', glyph: '⚖', description: 'Coming soon' },
];

export function QuickActionsPanel(): JSX.Element {
  const navigate = useNavigate();

  return (
    <Panel title="Quick Actions">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {ACTIONS.map((action) => {
          const isActive = Boolean(action.route);
          return (
            <button
              key={action.label}
              type="button"
              disabled={!isActive}
              aria-disabled={!isActive}
              title={action.description}
              onClick={isActive ? () => navigate(action.route!) : undefined}
              className={`group flex flex-col items-center gap-2 rounded-md border-2 px-3 py-5 min-h-[5.5rem] transition-all ${
                isActive
                  ? 'border-wood-mid/40 bg-parchment-light/50 text-ink cursor-pointer hover:border-candle hover:shadow-[0_0_12px_rgba(232,177,75,0.15)]'
                  : 'border-wood-mid/25 bg-parchment-light/50 text-ink-mid cursor-not-allowed opacity-70 hover:opacity-90'
              }`}
            >
              <span
                aria-hidden
                className={`inline-flex h-11 w-11 items-center justify-center rounded-full border-2 text-xl shadow-sm ${
                  isActive
                    ? 'border-candle/50 bg-gradient-to-b from-parchment to-parchment-dark/50 text-candle-dark'
                    : 'border-wood-mid/40 bg-gradient-to-b from-parchment to-parchment-dark/50 text-candle-dark'
                }`}
              >
                {action.glyph}
              </span>
              <span className="text-xs font-display uppercase tracking-[0.15em]">
                {action.label}
              </span>
              <span className="text-[10px] uppercase tracking-wider text-ink-light/80 italic">
                {action.description}
              </span>
            </button>
          );
        })}
      </div>
    </Panel>
  );
}
